import { AttachmentStateTypes, AttachmentActionTypes } from "./Attachment.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AttachmentStateTypes = {
  fetchAll: resetApiCallState([]),
};

const AttachmentReducer = (
  state: AttachmentStateTypes = INITIAL_STATE,
  action: any
): AttachmentStateTypes => {
  switch (action.type) {
    case AttachmentActionTypes.FETCH_ALL_ATTACHMENT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AttachmentActionTypes.FETCH_ALL_ATTACHMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AttachmentActionTypes.FETCH_ALL_ATTACHMENT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AttachmentActionTypes.FETCH_ALL_ATTACHMENT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AttachmentReducer;
